import { render, staticRenderFns } from "./NewTags.vue?vue&type=template&id=e1b05582&scoped=true&"
import script from "./NewTags.vue?vue&type=script&lang=js&"
export * from "./NewTags.vue?vue&type=script&lang=js&"
import style0 from "./NewTags.vue?vue&type=style&index=0&id=e1b05582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b05582",
  null
  
)

export default component.exports